import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatAutocompleteSelectedEvent, MatChipInputEvent, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ExamBoardService } from '../../../../../../services/exam-board/exam-board.service';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SubjectService } from '../../../../../../services/subject/subject.service';
import { Observable } from 'rxjs/Observable';
import { startWith, map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../../const/date-format';

@Component({
    selector: 'fuse-add-edit-exam-board',
    templateUrl: './add-edit-exam-board.component.html',
    styleUrls: ['./add-edit-exam-board.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class AddEditExamBoardComponent implements OnInit {
    form: FormGroup;
    mode: string;
    examCallId: number;
    schoolYearId: number;
    shifts: any[] = [];

    subjectCtrl = new FormControl();
    filteredSubjects: Observable<any[]>;
    selectedSubjects: any[] = [];
    allSubjects: any[] = [];

    separatorKeysCodes: number[] = [ENTER, COMMA];

    @ViewChild('subjectInput') subjectInput: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<AddEditExamBoardComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private examBoardService: ExamBoardService,
        private subjectService: SubjectService,
        private translationService: TranslationService
    ) {
        this.mode = data.mode;
        this.examCallId = data.examCallId;
        this.schoolYearId = data.schoolYearId;
        this.shifts = data.shifts;

        this.form = this._formBuilder.group({
            Id: [data.examBoard.Id || 0],
            ExamCallId: [this.examCallId, Validators.required],
            ShiftId: [data.examBoard.ShiftId, Validators.required],
            Date: [data.examBoard.Date, Validators.required],
            Time: [data.examBoard.Time, Validators.required],
            SubjectIds: [data.examBoard.SubjectIds || [], Validators.required]
        });

        if (this.mode === 'edit') {
            this.selectedSubjects = data.examBoard.SubjectIds.map((id, index) => ({
                Id: id,
                Name: data.examBoard.SubjectNames[index]
            }));
        }
    }

    ngOnInit() {
        this.filteredSubjects = this.subjectCtrl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value))
        );

        this.form.get('ShiftId').valueChanges.subscribe(shiftId => {
            this.selectedSubjects = [];
            this.updateSubjectIds();
            this.loadAvailableSubjects(shiftId);
        });

        if (this.form.get('ShiftId').value) {
            this.loadAvailableSubjects(this.form.get('ShiftId').value);
        }
    }

    private loadAvailableSubjects(shiftId: number) {
        if (shiftId) {
            this.subjectService.getBySchoolYearAndShift(this.schoolYearId, shiftId).subscribe(res => {
                this.allSubjects = res || [];
                // Trigger a value change to refresh filtered list
                this.subjectCtrl.setValue(this.subjectCtrl.value);
            });
        } else {
            this.allSubjects = [];
            this.subjectCtrl.setValue('');
        }
    }

    private _filter(value: any): any[] {
        const filterValue = (typeof value === 'string' ? value : '').toLowerCase();
        return this.allSubjects.filter(subject =>
            subject.Name.toLowerCase().includes(filterValue) &&
            !this.selectedSubjects.find(s => s.Id === subject.Id)
        );
    }

    addSubject(event: MatChipInputEvent): void {
        // We only add from autocomplete
    }

    removeSubject(subject: any): void {
        const index = this.selectedSubjects.indexOf(subject);
        if (index >= 0) {
            this.selectedSubjects.splice(index, 1);
            this.updateSubjectIds();
        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        if (!this.selectedSubjects.find(s => s.Id === event.option.value.Id)) {
            this.selectedSubjects.push(event.option.value);
            this.updateSubjectIds();
        }
        this.subjectInput.nativeElement.value = '';
        this.subjectCtrl.setValue(null);
    }

    updateSubjectIds() {
        this.form.get('SubjectIds').setValue(this.selectedSubjects.map(s => s.Id));
    }

    save() {
        if (this.form.invalid) return;

        const obs = this.mode === 'add'
            ? this.examBoardService.add(this.form.value)
            : this.examBoardService.update(this.form.value);

        obs.subscribe(res => {
            if (res.ResultCode === 1) {
                this.dialogRef.close(true);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-boards/components/add-edit-exam-board/add-edit-exam-board.component.ts